<template>
  <div>
    <top-bar heading="Roles"></top-bar>
    <loading-spinner :loading="!loaded"></loading-spinner>
    <div class="container-fluid mt-3" v-if="loaded">
      <b-card>
        <b-table responsive="md" striped hover :items="roles">

          <template slot="updated_at" slot-scope="data">
            {{ data.item.updated_at | moment('calendar') }}
          </template>

          <template slot="actions" slot-scope="data">
            <router-link :to="'/tools/roles/' + data.item.id" class="btn btn-primary btn-sm">Edit</router-link>
          </template>


          <template slot="user_guide" slot-scope="data">
            <a :href="data.item.user_guide" target="_blank" class="btn btn-primary btn-sm" v-if="data.item.user_guide">User Guide</a>
          </template>

        </b-table>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Roles',
  data () {
    return {
      roles: [],
      loaded: false
    };
  },
  methods: {
    getRoles () {
      this.loaded = false;
      this.axios.get('/roles').then(rsp => {
        this.roles = rsp.data.data.map(role => {
          role.actions = '';

          return role;
        });
        this.loaded = true;
      });
    }
  },
  mounted () {
    this.getRoles();
  },
  metaInfo: {
    title: 'Roles'
  }
};
</script>
